import FollowQuestionButton from './followQuestionButton'

export { FollowQuestionButton }
